// extracted by mini-css-extract-plugin
module.exports = {"closeAlertButton":"EGiftCard_closeAlertButton__3kmfu","imageUploader":"EGiftCard_imageUploader__2DFr3"};